import React from 'react';
import './CoFounders.css';

const CoFounders = () => {
  const coFounders = [
    {
      name: 'Hovarthan',
      title: 'Co-Founder',
      description: 'Data Scientist extracting insights and driving data-driven decisions through advanced analytics.',
      achievement: 'Expert in data science and predictive modeling'
    },
    {
      name: 'Sanjavi',
      title: 'Co-Founder',
      description: 'Data Analyst transforming raw data into actionable insights and business intelligence.',
      achievement: 'Specialized in data analysis and reporting'
    },
    {
      name: 'Sugumaran',
      title: 'Co-Founder',
      description: 'Web Developer creating modern, responsive websites and web applications.',
      achievement: 'Expert in web development technologies'
    }
  ];

  return (
    <section id="cofounders" className="cofounders">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Co-Founders</h2>
          <p className="section-subtitle">The Pillars of Our Success</p>
        </div>
        <div className="cofounders-grid">
          {coFounders.map((coFounder, index) => (
            <div key={index} className="cofounder-card">
              <div className="cofounder-image">
                <div className="cofounder-avatar">
                  {coFounder.name.split(' ').map(n => n[0]).join('')}
                </div>
              </div>
              <div className="cofounder-content">
                <h3 className="cofounder-name">{coFounder.name}</h3>
                <p className="cofounder-title">{coFounder.title}</p>
                <p className="cofounder-description">{coFounder.description}</p>
                <div className="cofounder-achievement">
                  <span className="achievement-icon">⭐</span>
                  <span className="achievement-text">{coFounder.achievement}</span>
                </div>
                {/* <div className="cofounder-social">
                  <a href="#" aria-label="LinkedIn" className="social-link">LinkedIn</a>
                </div> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CoFounders;

